module.exports = __webpack_public_path__ + "pattern_portrait.15c1a846.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/pattern_portrait.svg
// module id = jmRd
// module chunks = 0